//When a plan is purchased in the custom cart on the lawmatics or epusa website, the correspoinding matter is updated in lawmatics account of origin. However, we also create or update a matter in another lawmatics acount
//under Estate Plans USA. This function takes all data associated with the original Lawmatics matter, and maps it over to the correct IDs of custom field in the EPUSA lawmatics account and creates an object we can upload there.
//once the new atter is created in the Estate Plans USA lawmatics account, we add money to that matter's trust account and create a transaction for the amount purchased.

const transferService={}


 transferService.transferToEpusa=async(inheritguardMatterId,lawService,description,amount,isEPUSA,totalActualValue,setLoading)=> {
    const matterArray = [inheritguardMatterId]
    for (let i = 0; i < matterArray.length; i++) {
      const currentMatter = matterArray[i]
      await lawService.getAllMatterFields(currentMatter).then(async (r) => {
        //oldCustomFields=custom field values for exisitng matter that made the purchase from InheritGuard/Finlaw
        //customFieldObj=empty object of custom field arrays that we will populate with same values as old matter, but the IDs of the custom fields in the EPUSA lawmatics account
        let newMatter = { ...r.data.data }
        let oldCustomFields = r.data.data.attributes.custom_fields
        let newCustomFields = []
        let customFieldObj={}
        let newTags = ['Custom Plan']
        for (let i = 0; i < oldCustomFields.length; i++) {
          const currentCustomField = oldCustomFields[i]
          if (currentCustomField.id == '480999') {
            currentCustomField.id = '512331'
            newCustomFields.push(currentCustomField)
            customFieldObj.CRUT=currentCustomField.value
          }
          if (currentCustomField.id == '481389') {
            currentCustomField.id = '512332'
            newCustomFields.push(currentCustomField)
            customFieldObj.CMT=currentCustomField.value
          }
          if (currentCustomField.id == '480998') {
            currentCustomField.id = '512333'
            newCustomFields.push(currentCustomField)
            customFieldObj.DAPT=currentCustomField.value
          }
          if (currentCustomField.id == '467403') {
            currentCustomField.id = '512334'
            newCustomFields.push(currentCustomField)
            customFieldObj.familyGuardPlans=currentCustomField.value
          }
          if (currentCustomField.id == '481388') {
            currentCustomField.id = '512335'
            newCustomFields.push(currentCustomField)
            customFieldObj.LAPT=currentCustomField.value
          }
          if (currentCustomField.id == '480991') {
            currentCustomField.id = '512336'
            newCustomFields.push(currentCustomField)
            customFieldObj.SNT=currentCustomField.value
          }
          if (currentCustomField.id == '480992') {
            currentCustomField.id = '512337'
            newCustomFields.push(currentCustomField)
            customFieldObj.SNTwRLT=currentCustomField.value
          }
          if (currentCustomField.id == '480995') {
            currentCustomField.id = '512338'
            newCustomFields.push(currentCustomField)
            customFieldObj.LLCWealth=currentCustomField.value
          }
          if (currentCustomField.id == '480994') {
            currentCustomField.id = '512339'
            newCustomFields.push(currentCustomField)
            customFieldObj.LLCCorp=currentCustomField.value
          }
          if (currentCustomField.id == '480997') {
            currentCustomField.id = '512340'
            newCustomFields.push(currentCustomField)
            customFieldObj.MAPT=currentCustomField.value
          }
          if (currentCustomField.id == '480990') {
            currentCustomField.id = '512332'
            newCustomFields.push(currentCustomField)
            customFieldObj.RLTwSNT=currentCustomField.value
          }
          if (currentCustomField.id == '478675') {
            currentCustomField.id = '512343'
            newCustomFields.push(currentCustomField)
            customFieldObj.wealthGuardPlans=currentCustomField.value
          }
          if (currentCustomField.id == '480996') {
            currentCustomField.id = '512418'
            newCustomFields.push(currentCustomField)
            customFieldObj.IDGT=currentCustomField.value
          }
        if (currentCustomField.id == '515410') {
          currentCustomField.id = '515735'
          newCustomFields.push(currentCustomField)
          customFieldObj.powerOfAttorneyI=currentCustomField.value
        }
        if (currentCustomField.id == '515411') {
          currentCustomField.id = '515734'
          newCustomFields.push(currentCustomField)
          customFieldObj.powerOfAttorneyJ=currentCustomField.value
        }
        if (currentCustomField.id == '523618') {
          currentCustomField.id = '527202'
          newCustomFields.push(currentCustomField)
          customFieldObj.familyFoundationOperating=currentCustomField.value
        }
        if (currentCustomField.id == '523619') {
          currentCustomField.id = '527201'
          newCustomFields.push(currentCustomField)
          customFieldObj.familyFoundationNonOperating=currentCustomField.value
        }
        if (currentCustomField.id == '519736') {
          currentCustomField.id = '527200'
          newCustomFields.push(currentCustomField)
          customFieldObj.corporateKit=currentCustomField.value
        }
        if (currentCustomField.id == '495267') {
            //llc
            currentCustomField.id = '557425'
            newCustomFields.push(currentCustomField)
            customFieldObj.llcName=currentCustomField.value
          }
        if (currentCustomField.id == '443975') {
            //searching for who if anybody has a co counsel relationship in lawmatics with client and grabbing ID

                let coCounselResponse = await lawService.getContactById(currentCustomField.value)
                let newlyCreatedCoCounselResponse = await lawService.createEPUSAContact(coCounselResponse.data.data.attributes)
                newMatter.coCounselId=newlyCreatedCoCounselResponse.data.data.id
                customFieldObj.coCounselId=newlyCreatedCoCounselResponse.data.data.id

          }

          if (currentCustomField.id == '421736') {
             //searching for who if anybody has a spouse relationship in lawmatics with client and grabbing ID
            newMatter.spouseName=currentCustomField.formatted_value
            let spouseResponse = await lawService.getContactById(currentCustomField.value)
            let newlyCreatedSpouseResponse = await lawService.createEPUSAContact(spouseResponse.data.data.attributes)
            newMatter.newSpouseContactId=newlyCreatedSpouseResponse.data.data.id

          }
         }
        /////FOR SANDBOX MATTERS BELOW ////////

        // for (let i = 0; i < oldCustomFields.length; i++) {
        //   const currentCustomField = oldCustomFields[i]
        //   if (currentCustomField.id == '480999') {
        //     currentCustomField.id = '512469'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '481389') {
        //     currentCustomField.id = '512470'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480998') {
        //     currentCustomField.id = '512471'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '467403') {
        //     currentCustomField.id = '512472'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '481388') {
        //     currentCustomField.id = '512473'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480991') {
        //     currentCustomField.id = '512474'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480992') {
        //     currentCustomField.id = '512475'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480995') {
        //     currentCustomField.id = '512476'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480994') {
        //     currentCustomField.id = '512477'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480997') {
        //     currentCustomField.id = '512478'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480990') {
        //     currentCustomField.id = '512479'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '478675') {
        //     currentCustomField.id = '512480'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '480996') {
        //     currentCustomField.id = '512481'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '515410') {
        //     currentCustomField.id = '515738'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '515411') {
        //     currentCustomField.id = '515737'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '523618') {
        //     currentCustomField.id = '527198'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '523619') {
        //     currentCustomField.id = '527199'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '519736') {
        //     currentCustomField.id = '527197'
        //     newCustomFields.push(currentCustomField)
        //   }
        //   if (currentCustomField.id == '421736') {
        //     newMatter.spouseName = currentCustomField.formatted_value
        //     //newMatter.spouseId=currentCustomField.value
        //     let spouseResponse = await lawService.getContactById(currentCustomField.value)
        //     let newlyCreatedSpouseResponse = await lawService.createEPUSAContact(
        //       spouseResponse.data.data.attributes,
        //     )
        //     newMatter.newSpouseContactId = newlyCreatedSpouseResponse.data.data.id
        //     //  await lawService.getSpouse(currentCustomField.value)
        //     //    .then(async (r)=>{await lawService.createContact(r.data.data.attributes)
        //     //     .then((r)=>{newMatter.newSpouseContactId=r.data.data.id})})
        //   }
        // }

        ///sandBoxSpouseId: 459564
        ///EPUSASpouseId: 425285
        ///ignSpouseId:421736
        newCustomFields.push({
          id: '425285',
          name: 'Spouse',
          field_type: 'lookup',
          value: newMatter.newSpouseContactId,
        })
        customFieldObj.spouseId=newMatter.newSpouseContactId
        newMatter.attributes.custom_fields = newCustomFields
        newMatter.relationships.tags.data = newTags
        const firstName = newMatter.attributes['first_name']
        const lastName = newMatter.attributes['last_name']
        const spouseFirstname = newMatter.spouseName?.split(' ')[0]
        const spouseLastname = newMatter.spouseName?.split(' ')[1]
        if (spouseLastname === lastName) {
          newMatter.attributes.case_blurb = `${firstName}${spouseFirstname ? ` and ${spouseFirstname}` : ''} ${lastName} Estate Planning`
          newMatter.attributes.case_title = `${lastName}, ${firstName}${spouseFirstname ? ` and ${spouseFirstname}` : ''} EP`
        }
        if (spouseLastname != lastName) {
          newMatter.attributes.case_blurb = `${firstName} ${lastName}${spouseFirstname ? ` and ${spouseFirstname} ${spouseLastname}` : ''}  Estate Planning`
          newMatter.attributes.case_title = `${lastName}, ${firstName}${spouseFirstname ? ` and ${spouseFirstname} ${spouseLastname}` : ''} EP`
        }

        let matterToPush = { ...newMatter.attributes, tags: ['Custom Plan'] }
        if(isEPUSA===false)
        {
          //if the matter doesn't already exist in the EPSUA lawmatics account, creat the matter and transaction in the EPUSA lawmatics account
            lawService
            .createEPUSAMatter(matterToPush,customFieldObj)
            .then((r) => {
                let newMatterId = r.data.data.id
                transferService.onEPUSASuccess(newMatterId,lawService,description,amount,setLoading)
            })
            .catch((e) => {
              setLoading((ps) => {
                let pd = {...ps}
                pd.isError=true
                return pd;
              });
            })
        }
        else{
          //is matter already exists in EPUSA lawmatics, run an update and then add transaction
            lawService.updateEPUSAMatter(isEPUSA,totalActualValue,customFieldObj)
            .then((r)=>transferService.onEPUSASuccess(isEPUSA,lawService,description,amount,setLoading))
            .catch((e)=>setLoading((ps) => {
              let pd = {...ps}
              pd.isError=true
              return pd;
            }))

        }

      })
    }
  }

  //function to add baking info/transaction to the matter in the EPUSA lawmatics
transferService.onEPUSASuccess = (newMatterId,lawService,description,amount,setLoading) => {
    if(amount!=0){
    const safeDescription=description.replaceAll("/","%2F")
    let transactionObj = {
      transaction_type: 'credit',
      bank_account_type: 'trust',
      payment_method: "credit_card",
      executed_at: new Date(),
      amount_cents: amount,
      note: safeDescription,
      transactable_id: newMatterId,
      transactable_type: 'Prospect',
    }
    let timeEntryObj = {
      description: safeDescription,
      running_since: null,
      started_at:new Date(),
      completed_at: new Date(),
      billable: true,
      is_flat_fee: true,
      rate_flat_fee: amount,
      created_by_id: '23453',
      user_id: '23453',
      contactable_id: newMatterId,
      contactable_type: 'matter',
    }
    lawService
      .createEPUSATransaction(transactionObj)
      .then((r) => {
        console.log(r)
      })
      .catch((e) => {
        setLoading((ps) => {
          let pd = {...ps}
          pd.isError=true
          return pd;
        });
      })
      lawService
      .createEPUSATimeEntry(timeEntryObj)
      .then((r) => {
        console.log(r)
       let newTimeEntryId=r.data.data.id
       let newEntryObj={
          matterId:newMatterId,
          rate:amount,
          timeEntryId:newTimeEntryId
        }
        lawService.updateEPUSATimeEntry(newEntryObj).then((r) => {
          console.log(r)
          setLoading((ps) => {
            let pd = {...ps}
            pd.goodToClose=true
            return pd;
          });
        })
        .catch((e) => {
          setLoading((ps) => {
            let pd = {...ps}
            pd.isError=true
            return pd;
          });
        })
      })
      .catch((e) => {
        setLoading((ps) => {
          let pd = {...ps}
          pd.isError=true
          return pd;
        });
      })
    }
  }



  export default transferService